// extracted by mini-css-extract-plugin
export default {"rotate":"Player_rotate__+hds+","rotation":"Player_rotation__gSPIG"};